module.exports = __webpack_public_path__ + "static/img/dark_spots-01.d4a17bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/dark_spots-01.jpg
// module id = 256
// module chunks = 1